<template>
  <div>
    <pageHeader :headerIcon="'dolly flatbed'"
                :headerText="'Clinics'"
                :haveFilterInput="false">
    </pageHeader>

    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else class="ui three column grid" style="margin-top: 40px !important">
      <div class="column" v-for="clinic in clinics">
        <div class="ui raised link fluid stackable blue card"
             @click="goToHomeWithClinic(clinic)">
          <div class="content">
            <div class="header" style="display:flex; align-items:center">
              {{ clinic.name }}
            </div>

            <div class="description">
              <strong> Address: </strong> {{ clinic.address }}
            </div>
            <div class="description">
              <strong> Cell Phone: </strong> {{ clinic.cell_phone }}
            </div>
            <div class="description">
              <strong> Telephone: </strong> {{ clinic.telephone }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      clinics: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get('clinics').then(response => {
      this.clinics = response.data
      this.loading = false
    })
  },
  methods: {
    goToHomeWithClinic (clinic) {
      this.setClinicToStore(clinic)
      this.navigateTo('Home')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/clinics/Clinics.vue